<template>
        <ul class="select_presets">
            <li class="select_preset__item" :class="{active: preset === path}" v-for="path in imagePathList" :key="path" @click="() => $emit('setBgImage', path)">
                <img :src="require(`../../assets/img/select/scenes/${path}.jpg`)" :alt="path">
             </li>
        </ul>
</template>

<script>
    export default {
        name: "SelectPresetScene",
        props: {
            dirname: {
                type: String,
                required: true
            },
            prefix: {
                type: String,
                required: true
            },
            samples: {
                type: Array,
                default: () => []
            },
            preset: {
                type: String
            }
        },
        computed: {
            imagePathList () {
                return this.samples.map((num) => {
                    return `${this.dirname}/${this.prefix}_${num}`
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    .select_presets {
        display: flex;
        margin: 0;
        padding: 0;
        justify-content: space-between;
            flex-wrap: wrap;
            width: 100%;
        .select_preset__item {
            list-style: none;
            width: calc(50% - 10px);
            margin-bottom: 10px;
            cursor: pointer;
            img{
                    width: 100%;
            }
            &.active {
                img {
                    border: 1px solid #000;
                }
            }
        }
    }
</style>
